var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3849 15.959H2.28802V6.45435H14.3849M11.7924 0.405762V2.13389H4.87994V0.405762H3.15182V2.13389H2.28776C1.32865 2.13389 0.559631 2.9029 0.559631 3.86201V15.9589C0.559631 16.9094 1.33729 17.687 2.28776 17.687H14.3846C15.3351 17.687 16.1128 16.9094 16.1128 15.9589V3.86201C16.1128 2.9029 15.3351 2.13389 14.3846 2.13389H13.5206V0.405762M12.6562 9.90991H8.33594V14.2302H12.6562V9.90991Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderMark);
export default __webpack_public_path__ + "static/media/calender-mark.72cfecdbe8b079ac2e7d5da0700b27aa.svg";
export { ForwardRef as ReactComponent };